import { useDispatch } from "react-redux";

import { DesktopRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const SellingPageVisitedActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={DesktopRegularV6}>
            Selling Page Visit
          </CategoryContainer>
        }
        personName={`${activity.data.leadFirstName} ${activity.data.leadLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <span className={`${STYLES.lineClamp3} tw-px-8px`}>
        {activity.data.leadFirstName} has visited the Selling page on your website.
      </span>
      <ActivityBtns
        callHandlr={() => {
          if (activity?.personUuid) {
            dispatch(
              setCallParams({ leadUuids: [activity.personUuid], callSource: "Selling Page Visit Activity" }),
            );
          }
        }}
        containerClassName="!tw-mt-8px"
      />
    </ActivityContainer>
  );
};

export default SellingPageVisitedActivity;

SellingPageVisitedActivity.propTypes = {
  ...activityCommonPropTypes,
};

SellingPageVisitedActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
